/**
 * @fileoverview GET handler for the "/:app_group_id/canvas_qa_runs/:canvas_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { canvasQaRun } from "./constants";
import type { GetCanvasQaRunProps, GetCanvasQaRunResult } from "./types";
import { isGetCanvasQaRunResult } from "./validators";

export const getCanvasQaRun = reactQueryFetcherAdapter(
  canvasQaRun,
  (signal: AbortSignal, { appGroupId, canvasId }: GetCanvasQaRunProps): Promise<GetCanvasQaRunResult> => {
    return fetch(
      `/${appGroupId}/canvas_qa_runs/${canvasId}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  },
  isGetCanvasQaRunResult
);
